import { OfferType } from '@occc-app/offerValidationService/types';

import { LinkItem } from '@occc-app/design-system';
import { Random_Award_Type } from '@occc/graphql';
import { messages } from './messages';
import { createRouteCreator as createProgramManagementRouteCreator } from '../ProgramManagement/utils';
import { createRouteCreator as createCampaignManagementRouteCreator } from '../CampaignComponents/utils';

export const campaignManagementGameRouteCreator = createCampaignManagementRouteCreator(
  OfferType.FreeGame,
);

export const programManagementGameRouteCreator = createProgramManagementRouteCreator(
  OfferType.VoucheredGame,
);

export const getProgramManagementGameDetailsPageHeaderLinks = (
  offerName?: string,
  offerId?: string,
): LinkItem[] => [
  {
    to: programManagementGameRouteCreator.base(),
    label: 'Program Management',
  },
  {
    to: programManagementGameRouteCreator.base(),
    label: messages.title,
  },
  {
    key: offerId
      ? programManagementGameRouteCreator.details(offerId)
      : programManagementGameRouteCreator.base(),
    label: offerName,
  },
];

export const hasAwardSegment = (segments: { type: Random_Award_Type }[]): boolean =>
  segments.some(
    (s) => s.type === Random_Award_Type.Points || s.type === Random_Award_Type.Vouchers,
  );
